export const ATLAS_Z_FRAME_PRESENT = "z-[46]";
export const ATLAS_Z_DOCKED_TOOLBAR = "z-[49]";
export const ATLAS_Z_EC_FULLSCREEN = "z-[50]";
export const ATLAS_Z_APP_LAYOUT_CLUSTER = "z-20";
export const ATLAS_Z_DEV_GUIDE = "z-[100]";
